const DiscountTypes = {
  PRICE: 1,
  PERCENTAGE: 2,
  FREE_SHIPPING: 3
}

export default DiscountTypes
